import React from 'react';
import { Link } from 'react-router-dom';
import imgHome from '../assets/img_home2.png';
import esgSilver from '../assets/ESG_silver.png';
import esgGold from '../assets/ESG_gold.png';
import esgBronze from '../assets/ESG_bronze.png';
import esgPatinum from '../assets/ESG_platinum.png';

const pillars = [
  {
    icon: '🌱',
    title: 'Environmental',
    color: '#EAF3DE',
    desc: 'Efficienza energetica, consumo computazionale, ottimizzazione infrastruttura e riduzione dell\'impatto ambientale del software.',
  },
  {
    icon: '🤝',
    title: 'Social',
    color: '#E6F1FB',
    desc: 'Accessibilità WCAG, inclusività, privacy degli utenti, benessere del team e impatto sociale positivo del prodotto.',
  },
  {
    icon: '⚖️',
    title: 'Governance',
    color: '#FAEEDA',
    desc: 'Processi responsabili, tracciabilità del codice, gestione rischi ESG, certificazioni e rendicontazione.',
  },
];

const levels = [
  { num: 1, label: 'Base', range: '0–15 pt', img: esgBronze, desc: 'Prime adozioni ESG, conformità ai requisiti fondamentali.', color: '#c9e2a5' },
  { num: 2, label: 'Inremedio', range: '0–15 pt', img: esgSilver, desc: 'Prime adozioni ESG, conformità ai requisiti fondamentali.', color: '#97C459' },
  { num: 3, label: 'Avanzato', range: '16–30 pt', img: esgGold, desc: 'Integrazione strutturata nel ciclo di sviluppo.', color: '#1D9E75', featured: true },
  { num: 4, label: 'Eccellenza', range: '31–45 pt', img: esgPatinum, desc: 'Leadership ESG, rendicontazione completa e best practice.', color: '#085041' },
];

const steps = [
  { n: '1', label: 'Registrati', desc: 'Crea il tuo account e il profilo azienda' },
  { n: '2', label: 'Aggiungi progetto', desc: 'Inserisci i dati del software da certificare' },
  { n: '3', label: 'Compila questionario', desc: 'Rispondi alle domande E, S, G in modalità wizard' },
  { n: '4', label: 'Valutazione', desc: 'Ricevi il punteggio automatico e il livello stimato' },
  { n: '5', label: 'Certificato', desc: 'Il certificatore rivede e rilascia il certificato ufficiale' },
];

export default function HomePage() {
  return (
    <div>
      {/* Hero */}
      <section style={{ background: 'white', padding: '72px 24px 56px', textAlign: 'center', borderBottom: '1px solid #E0DED6' }}>
        <div style={{ maxWidth: 622, margin: '0 auto' }}>
          <img src='/Logo_or.png' alt='logoESG' style={{width:'30%'}} /><br />
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#EAF3DE', color: '#3B6D11', borderRadius: 20, padding: '4px 14px', fontSize: 12, fontWeight: 500, marginBottom: 20 }}>
            Basato su ISO 42001
          </div>
          <h1 style={{ fontSize: 42, fontWeight: 500, lineHeight: 1.15, marginBottom: 16 }}>
            Certifica la sostenibilità del tuo software
          </h1>
          <img src={imgHome} alt='img_home' style={{width:'69%'}} />
          <p style={{ fontSize: 17, color: '#5C5B55', marginBottom: 32, lineHeight: 1.65 }}>
            Trasforma la sostenibilità in vantaggio competitivo con la compliance ESG Software <br />
            Un percorso guidato per valutare i tuoi progetti software secondo i criteri ESG — ambientali, sociali e di governance — e ottenere un certificato riconosciuto.
          </p>
          
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-primary btn-lg">Inizia gratuitamente</Link>
            <a href="#come-funziona" className="btn btn-outline btn-lg">Come funziona</a>
          </div>
        </div>
      </section>

      {/* Pillars */}
      <section style={{ padding: '56px 24px', background: '#F8F8F6', borderBottom: '1px solid #E0DED6' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 36 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#1D9E75', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 8 }}>I tre pilastri</div>
            <h2 style={{ fontSize: 28 }}>Cos'è la compliance ESG per il software</h2><br />
             <p><strong>ESG</strong>  è l’acronimo di <strong>Environmental, Social, e Governance</strong> . Questi tre pilastri rappresentano 
              un quadro di riferimento per misurare la sostenibilità e l’impatto etico di un’azienda o, 
              nel nostro caso, di un progetto. Non si tratta solo di conformità normativa, ma di un approccio 
              strategico che integra considerazioni ambientali, sociali e di governance nelle decisioni aziendali.</p>
            <p style={{ color: '#5C5B55', marginTop: 10, maxWidth: 580, margin: '10px auto 0' }}>
              ESG non è solo per le grandi aziende. <br /> Ogni progetto software ha un impatto — misurarlo è il primo passo per migliorarlo.
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
            {pillars.map(p => (
              <div key={p.title} className="card">
                <div style={{ width: 40, height: 40, borderRadius: 10, background: p.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, marginBottom: 14 }}>{p.icon}</div>
                <h3 style={{ fontSize: 16, marginBottom: 8 }}>{p.title}</h3>
                <p style={{ fontSize: 14, color: '#5C5B55', lineHeight: 1.6 }}>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Levels */}
      <section style={{ padding: '56px 24px', background: 'white', borderBottom: '1px solid #E0DED6' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 36 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#1D9E75', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 8 }}>Certificazione</div>
            <h2 style={{ fontSize: 28 }}>Tre livelli di riconoscimento</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
            {levels.map(l => (
              <div key={l.num} className="card" style={{ textAlign: 'center', border: l.featured ? `2px solid ${l.color}` : undefined }}>
                {l.featured && <div style={{ fontSize: 11, fontWeight: 600, color: l.color, marginBottom: 8 }}>PIÙ COMUNE</div>}
                <div style={{ width: 52, height: 52, borderRadius: '50%', background: l.color, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', color: 'white', fontSize: 22, fontWeight: 700 }}>{l.num}</div>
                <h3 style={{ fontSize: 17, marginBottom: 4 }}>Livello {l.num} — {l.label}</h3>
                <img src={l.img} alt='esgLevel' style={{width:'35%'}} />
                {/* <div style={{ fontSize: 12, color: '#9B9A92', marginBottom: 10 }}>{l.range}</div> */}
                <p style={{ fontSize: 13, color: '#5C5B55' }}>{l.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="come-funziona" style={{ padding: '56px 24px', background: '#F8F8F6', borderBottom: '1px solid #E0DED6' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 36 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#1D9E75', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 8 }}>Processo</div>
            <h2 style={{ fontSize: 28 }}>Come funziona</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16 }}>
            {steps.map((s, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#1D9E75', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 16, margin: '0 auto 12px' }}>{s.n}</div>
                <h4 style={{ fontSize: 14, marginBottom: 5 }}>{s.label}</h4>
                <p style={{ fontSize: 13, color: '#5C5B55' }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '56px 24px', background: '#1D9E75', textAlign: 'center' }}>
        <div style={{ maxWidth: 520, margin: '0 auto' }}>
          <h2 style={{ fontSize: 28, color: 'white', marginBottom: 14 }}>Pronto a certificare il tuo software?</h2>
          <p style={{ color: 'rgba(255,255,255,0.8)', marginBottom: 28 }}>Registrati gratuitamente e inizia il tuo percorso ESG in pochi minuti.</p>
          <Link to="/register" className="btn btn-lg" style={{ background: 'white', color: '#1D9E75', fontWeight: 600 }}>Inizia ora</Link>
        </div>
      </section>     
    </div>
  );
}
